import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
    const access_token = localStorage.getItem("access_token");

    if(access_token){
        return <Navigate to="/app/home" replace />
    }

    return <Outlet></Outlet>
}

export default PublicRoute;